import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useOccSubcomponents } from '../../../../context/occ/hooks/use-occ-subcomponents';
export const Input = forwardRef((props, forwardedRef) => {
    const { Input: InputComponent } = useOccSubcomponents();
    return _jsx(InputComponent, Object.assign({}, props, { ref: forwardedRef }));
});
Input.displayName = 'Input';
